import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import Select from '../../../../components/Select';
import t from '../../../../lib/translate';
import { getOwnerParties } from '../../../../api';
var OwnerpartySelector = function (props) {
    var _a = useState([]), ownerparties = _a[0], setOwnerParties = _a[1];
    var onChange = props.onChange;
    useEffect(function () {
        getOwnerParties().then(function (res) {
            setOwnerParties(res);
        });
    }, []);
    useEffect(function () {
        if (ownerparties.length > 0) {
            onChange(ownerparties[0].key);
        }
    }, [ownerparties, onChange]);
    return (_jsx(Select, { label: t('templates.create.ownerparty'), onChange: function (event) {
            // @ts-ignore
            onChange(event.value);
        }, options: ownerparties.map(function (ownerparty) { return ({ value: ownerparty.key, label: ownerparty.name }); }) }));
};
export default OwnerpartySelector;
